const I18N_DOMAIN_COMPONENTS = 'tui-components';

export const CIRCULAR_PROGRESS_SIZE = {
	small: 'small',
	default: 'default',
	large: 'large',
};

export default I18N_DOMAIN_COMPONENTS;
